/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import colors from '@salesforce/retail-react-app/app/theme/foundations/colors'
import variables from './variables.module.scss'

// Neutral
colors.neutral = {
    50: variables?.neutral50,
    100: variables?.neutral100
}

// Gray
colors.grayAlpha5 = variables?.grayAlpha5
colors.grayAlpha3 = variables?.grayAlpha3
colors.blackAlpha1 = variables?.blackAlpha1
colors.blackAlpha600 = variables?.blackAlpha600
colors.blackAlpha610 = variables?.blackAlpha610
colors.whiteAlpha25 = variables?.whiteAlpha25

colors.gray = {
    ...colors.gray,
    30: variables?.gray30,
    40: variables?.gray40,
    50: variables?.gray50,
    100: variables?.gray100,
    200: variables?.gray200,
    300: variables?.gray300,
    350: variables?.gray350,
    375: variables?.gray375,
    400: variables?.gray400,
    425: variables?.gray425,
    450: variables?.gray450,
    500: variables?.gray500,
    530: variables?.gray530,
    550: variables?.gray550,
    600: variables?.gray600,
    650: variables?.gray650,
    700: variables?.gray700,
    750: variables?.gray750,
    800: variables?.gray800,
    850: variables?.gray850,
    900: variables?.gray900
}

// Black
colors.black = variables?.black
colors.black = {
    50: variables?.black50,
    100: variables?.black100,
    200: variables?.black200,
    300: variables?.black300
}

// Red
colors.red = {
    ...colors.red,
    18: variables?.red18,
    20: variables?.red20,
    30: variables?.red30,
    100: variables?.red100,
    200: variables?.red200,
    400: variables?.red400,
    950: variables?.red950
}

// Teal
colors.teal = {
    ...colors.teal,
    400: variables?.teal400,
    500: variables?.teal500,
    600: variables?.teal600
}

colors.blue = {
    ...colors.blue,
    200: variables?.blue200,
    600: variables?.blue600
}

// White
colors.white = variables?.white

// Yellow
colors.yellow = {
    ...colors.yellow,
    200: variables?.yellow200,
    300: variables?.yellow300,
    400: variables?.yellow400,
    600: variables?.yellow600
}

// Blue
colors.blue = {
    ...colors.blue,
    700: variables?.blue700,
    800: variables?.blue800
}

// Purple
colors.purple = {
    ...colors.purple,
    25: variables?.purple25,
    60: variables?.purple60,
    75: variables?.purple75,
    80: variables?.purple80,
    90: variables?.purple90,
    100: variables?.purple100,
    300: variables?.purple300,
    600: variables?.purple600,
    700: variables?.purple700
}

// Green
colors.green = {
    ...colors.green,
    100: variables?.green100,
    300: variables?.green300,
    150: variables?.green150,
    500: variables?.green500,
    600: variables?.green600,
    700: variables?.green700,
    720: variables?.green720
}

// Mango
colors.mango = {
    400: variables?.mango400
}

// peach
colors.peach = {
    100: variables?.peach100
}

// Warm
colors.warm = {
    400: variables?.warm400
}

// Gradients
colors.gradientMinicartHover = variables?.gradientMinicartHover
colors.gradientImageView = variables?.gradientImageView
colors.gradientRightShadow = variables?.gradientRightShadow
colors.searchBarShadow = variables?.searchBarShadow
colors.sizeGuideShadow = variables?.sizeGuideShadow
colors.ksBrandGradient = variables?.ksBrandGradient
colors.ksSpinnerOverlay5 = variables?.ksSpinnerOverlay5
colors.ksSpinnerOverlay6 = variables?.ksSpinnerOverlay6
colors.ksUtilityGradient = variables?.ksUtilityGradient
colors.yrUtilityGradient = variables?.yrUtilityGradient
colors.colorbarGradient = variables?.colorbarGradient
colors.thumbnailGradient = variables?.thumbnailGradient
colors.customerDetailsBorder = variables?.customerDetailsBorder

export default colors
